export const toFixed2 = (value: number, currencySign = "$", comma = true) => {
  if (value < 0.01 && value >= 0) return `<${"\u00A0"}${currencySign}0.01`;

  let valueStr = (typeof value === "number" ? value : 0).toFixed(2);

  if (comma) {
    const arr = valueStr.split(".");
    const left = arr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    valueStr = `${left}.${arr[1]}`;
  }

  return `${currencySign}${valueStr}`;
};
